import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { httpClient } from '@/api/http-client'
import { ManualPaymentSlip } from '@/types'

export type UpdateManualPaymentSlipPaidParams = {
  company_key: string
  paid: boolean
  slip_key: string
}

export async function updateManualPaymentSlipPaid({
  company_key,
  paid,
  slip_key,
}: UpdateManualPaymentSlipPaidParams) {
  const response = await httpClient('accounting-dealer').put<ManualPaymentSlip>(
    `/v3/company/${company_key}/manual-payment-slips/${slip_key}/paid`,
    { paid },
  )

  return response.data
}

export function useUpdateManualPaymentSlipPaid(
  options?: UseMutationOptions<
    ManualPaymentSlip,
    AxiosError,
    UpdateManualPaymentSlipPaidParams
  >,
) {
  return useMutation({
    mutationFn: updateManualPaymentSlipPaid,
    ...options,
  })
}
